import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { EnquiryForm } from "@/components/EnquiryForm";
import { SITE } from "@/config/site";
import { getPageSeo, type PageSeo } from "@/lib/api/seo.functions";
import { mergeSeo } from "@/lib/seo-head";

export const Route = createFileRoute("/enquiry")({
  loader: () => getPageSeo({ data: { path: "/enquiry" } }),
  head: ({ loaderData }) => mergeSeo({
    meta: [
      { name: "robots", content: "index, follow" },
      { title: "Send an Enquiry · Surer Adda With Sanchayeeta" },
      { name: "description", content: "Send a booking enquiry to Sanchayeeta Seal — live performance, versatile singing, voiceover & music albums. Pan-India." },
      { property: "og:title", content: "Enquiry · Surer Adda" },
      { property: "og:description", content: "Share your event details and get a response from Sanchayeeta Seal's team within 24 hours." },
      { property: "og:url", content: `${SITE.url}/enquiry` },
    ],
    links: [{ rel: "canonical", href: `${SITE.url}/enquiry` }],
  }, loaderData as PageSeo | null),
  component: EnquiryPage,
});

function EnquiryPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <div className="mb-8 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">Get in Touch</p>
          <h1 className="mt-2 text-4xl sm:text-5xl">Send an Enquiry</h1>
          <p className="mt-3 text-muted-foreground">Share a few details and we'll get back to you.</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-6 shadow-sm sm:p-10">
          <EnquiryForm />
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
